import { render, staticRenderFns } from "./PermissionCard.vue?vue&type=template&id=c48175e2&scoped=true"
import script from "./PermissionCard.vue?vue&type=script&lang=js"
export * from "./PermissionCard.vue?vue&type=script&lang=js"
import style0 from "./PermissionCard.vue?vue&type=style&index=0&id=c48175e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48175e2",
  null
  
)

export default component.exports